// src/app/views/pages_admin/exam_sheet/examSheet-routes.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const ExamSheet = Loadable(lazy(() => import("./ExamSheet")));

const routes = Object.values(EXAM_TYPES).map(examType => ({
  path: `${examType.pathPrefix}/exam-sheet`,
  element: <ExamSheet />
}));

export default routes;
